var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVolkswagenBrand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2072_55200)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9908 0.712891C11.1249 0.712891 0.695312 11.143 0.695312 24.0084C0.695312 36.874 11.1251 47.3039 23.9908 47.3039C36.8559 47.3039 47.2863 36.874 47.2863 24.0084C47.2863 11.1432 36.8559 0.712891 23.9908 0.712891ZM23.9908 45.2152C12.2784 45.2152 2.78397 35.7207 2.78397 24.0084C2.78397 12.2965 12.2784 2.8018 23.9908 2.8018C35.7027 2.8018 45.1976 12.2965 45.1976 24.0084C45.1976 35.7207 35.7027 45.2152 23.9908 45.2152Z",
    fill: "#6A6F73"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3481 8.1656C20.8565 7.72526 22.4199 7.50245 23.9912 7.50391C25.6012 7.50391 27.1576 7.73452 28.6289 8.16435L23.9912 18.4445L19.3481 8.1656Z",
    fill: "#6A6F73"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.8508 10.0801C34.5889 11.1889 36.1054 12.6116 37.3228 14.2756L29.7108 31.1203L26.7734 24.5889H21.208L18.2708 31.12L10.6698 14.2599C11.8848 12.6026 13.3971 11.1853 15.1298 10.0803L21.208 23.5646H26.7923L32.8508 10.0801ZM8.04247 19.7369C7.67089 21.1305 7.48327 22.5666 7.48438 24.0089C7.48438 30.4775 11.2047 36.0766 16.6225 38.7839L8.04247 19.7369Z",
    fill: "#6A6F73"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.4248 39.8758C20.9095 40.3017 22.4466 40.517 23.9911 40.5156C25.5735 40.5156 27.1036 40.2927 28.5519 39.8775L23.9911 29.7485L19.4248 39.8758ZM31.3586 38.7843C36.7766 36.077 40.4969 30.478 40.4969 24.0093C40.4969 22.5449 40.3061 21.1252 39.9488 19.7734L31.3586 38.7843Z",
    fill: "#6A6F73"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2072_55200"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolkswagenBrand);
export default __webpack_public_path__ + "static/media/volkswagen-brand.4f91d001a4e74a89539b3b56af421eaa.svg";
export { ForwardRef as ReactComponent };